import { render, staticRenderFns } from "./AppSettingsSync.vue?vue&type=template&id=bcc71910&scoped=true&"
import script from "./AppSettingsSync.vue?vue&type=script&lang=js&"
export * from "./AppSettingsSync.vue?vue&type=script&lang=js&"
import style0 from "./AppSettingsSync.vue?vue&type=style&index=0&id=bcc71910&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc71910",
  null
  
)

export default component.exports